import { Component, OnInit, DoCheck } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { CloseOverlayService } from '../../_services/closeOverlay.service';
import { Location } from '@angular/common';
import { ShadowService } from '../../_services/shadow.service';
import { LoginStore } from '../../_services/store';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.page.html',
  styleUrls: ['./terms.page.scss'],
})
export class TermsPage implements OnInit, DoCheck {
  onSignup = false;
  subscription: any;

  constructor(
    private modalController: ModalController,
    private platform: Platform,
    private shadowService: ShadowService,
    private router: Router,
    private location: Location,
    private closeOverlayService: CloseOverlayService,
    private loginStore: LoginStore
  ) {}

  closeModal() {
    this.modalController.dismiss();
  }

  demoTransaction() {
    this.modalController.dismiss();
    this.router.navigateByUrl('demo/payment');
    this.loginStore.setIsTermsAgreed(true);
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        if (this.constructor.name === 'TermsPage') {
          this.closeOverlayService.trigger();
        } else {
          this.location.back();
        }
      }
    );
  }

  ionViewWillEnter() {
    this.shadowService.transparentButton();
    this.shadowService.button();
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {}

  ngDoCheck(): void {
    if (this.loginStore.getIsSignupPage()) {
      this.onSignup = true;
      document.getElementById('mb-last').style.marginBottom = '60px';
    }
  }
}
